import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Site } from '../../../../../hooks/useSites/models';

/**
 * Vertical offset from cursor position (pixels).
 * Positions tooltip above the cursor.
 */
const TOOLTIP_OFFSET_Y = 10;

interface SitePinHoverTooltipProps {
  /** The site data to display */
  site: Site;
  /** Screen position from DeckGL picking (viewport-relative) */
  position: { x: number; y: number };
}

/**
 * SitePinHoverTooltip displays site information when hovering over a site pin.
 * Shows the site name and address.
 */
export function SitePinHoverTooltip({ site, position }: SitePinHoverTooltipProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'fixed',
        left: position.x,
        top: position.y - TOOLTIP_OFFSET_Y,
        transform: 'translate(-50%, -100%)',
        zIndex: 1500,
        pointerEvents: 'none',
        bgcolor: 'background.paper',
        borderRadius: theme.brandV2.borderRadius,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        px: 1.5,
        py: 1,
        maxWidth: 280,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          fontSize: '13px',
          color: theme.brandV2.colors.treadBlack,
          wordBreak: 'break-word',
          lineHeight: 1.3,
        }}
      >
        {site.name}
      </Typography>
      {site.fullAddress && (
        <Typography
          variant="body2"
          sx={{
            fontSize: '12px',
            color: theme.brandV2.colors.treadGray3,
            mt: 0.25,
            wordBreak: 'break-word',
          }}
        >
          {site.fullAddress}
        </Typography>
      )}
    </Box>
  );
}
